<script setup>
import { computed } from 'vue'

const FACEBOOK_APP_ID = 126928420652882
const SHARE_WINDOW_FEATURES = 'width=400, height=300'

const props = defineProps({
    url: {
        type: String,
        default: '',
        required: true,
    },
    customText: {
        type: String,
        default: 'Hello World',
    },
    type: {
        type: String,
        default: '',
        required: true,
    },
})

const isFacebook = computed(() => props.type === 'facebook')

const sharerUrl = computed(() =>
    isFacebook.value
        ? `https://www.facebook.com/dialog/share?app_id=${FACEBOOK_APP_ID}&href=${props.url}`
        : `https://twitter.com/intent/tweet?text=${encodeURIComponent(props.customText)} ${props.url}`
)

function share() {
    window.open(sharerUrl.value, `${props.type} Share Window`, SHARE_WINDOW_FEATURES)
}
</script>

<template>
    <span
        class="social-share"
        @click="share"
    >{{ isFacebook ? 'Facebook' : 'Twitter' }}</span>
</template>

<style lang="scss" scoped>
@import '@design';

.social-share {
    display: block;
    pointer-events: auto;
    cursor: pointer;
}
</style>
